module.exports = __webpack_public_path__ + "static/media/coffeebar_thumb.3570223c.jpg";